import React, { Fragment } from "react";
import { __ } from "@wordpress/i18n";
import { PluginCard } from "./plugin-card";

// Access the localized free plugins data
const MAJOR_PLUGINS_OBJ =
  window.wpmudev_cross_sell_data.plugins_list.major || [];
const MAJOR_PLUGINS = Object.values(MAJOR_PLUGINS_OBJ);

const MINOR_PLUGINS_OBJ =
  window.wpmudev_cross_sell_data.plugins_list.minor || [];
const MINOR_PLUGINS = Object.values(MINOR_PLUGINS_OBJ);

const Plugins = () => {
  return (
    <Fragment>
      {MAJOR_PLUGINS.map((plugin) => (
        <PluginCard
          key={plugin.slug}
          className="cross-sell-card--major"
          cta={true}
          extended_view={true}
          {...plugin}
        />
      ))}
      {MINOR_PLUGINS.map((plugin) => (
        <PluginCard
          key={plugin.slug}
          className="cross-sell-card--minor"
          cta={true}
          {...plugin}
        />
      ))}
    </Fragment>
  );
};

export { Plugins };
